import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { TableActionHeader } from 'components/Global';
import { AddSvg } from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import ExpenseGroupsTable from './ExpenseGroupsTable';
import AddEditExpenseGroup from './AddEditExpenseGroup';
import { SideDrawerWrapper } from 'components/Global';


interface ExpenseGroupsProps {
    closeDrawerByAnimation: () => void;
    setSelectedSidebar: (sidebar: string) => void;
    openDrawerHandler: () => void;
}

const ExpenseGroups: FC<ExpenseGroupsProps> = (props) => {
    const { openDrawerHandler, closeDrawerByAnimation } = props;

    const selectedCompanyPermission = useSelector(
        (state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
    );

    const [isSideDrawerOpen, setIsSideDrawerOpen] = useState(false);
    const [drawerAnimation, setDrawerAnimation] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editExpenseGroup, setEditExpenseGroup] = useState(null);

    const isAddPermission = checkPermission(selectedCompanyPermission, {
        permissionName: 'Expense Groups',
        permission: ['add'],
    });

    const isEditPermission = checkPermission(selectedCompanyPermission, {
        permissionName: 'Expense Groups',
        permission: ['edit'],
    });

    const isDeletePermission = checkPermission(selectedCompanyPermission, {
        permissionName: 'Expense Groups',
        permission: ['delete'],
    });

    const openDrawer = (isEdit = false, expenseGroup = null) => {
        setIsEditMode(isEdit);
        setEditExpenseGroup(expenseGroup);
        setIsSideDrawerOpen(true);
        setDrawerAnimation(true);
        openDrawerHandler();
    };

    const closeDrawer = () => {
        setDrawerAnimation(false);
        setTimeout(() => {
            setIsSideDrawerOpen(false);
            setIsEditMode(false);
            setEditExpenseGroup(null);
            // Don't call closeDrawerByAnimation() here as it closes the main settings drawer
        }, 300);
    };

    const removeDrawerFromDom = () => {
        setIsSideDrawerOpen(false);
        setIsEditMode(false);
        setEditExpenseGroup(null);
    };

    const handleEdit = (expenseGroup: any) => {
        openDrawer(true, expenseGroup);
    };

    const handleCreate = () => {
        openDrawer(false, null);
    };

    return (
        <>
            <div>
                <TableActionHeader title="Expense Groups">
                    {isAddPermission && (
                        <button
                            className={`btn-black`}
                            onClick={handleCreate}
                        >
                            <AddSvg />
                            <p>Add Expense Group</p>
                        </button>
                    )}
                </TableActionHeader>

                <ExpenseGroupsTable
                    onEdit={handleEdit}
                    closeDrawerByAnimation={closeDrawerByAnimation}
                    isEditPermission={isEditPermission}
                    isDeletePermission={isDeletePermission}
                />

                {isSideDrawerOpen && (
                    <SideDrawerWrapper
                        isOpen={drawerAnimation}
                        removeDrawerFromDom={removeDrawerFromDom}
                        closeDrawerByAnimation={closeDrawer}
                        headerTitle={isEditMode ? 'Edit Expense Group' : 'Create Expense Group'}
                        position="right"
                        width="half"
                    >
                        <AddEditExpenseGroup
                            closeDrawerByAnimation={closeDrawer}
                            isEditMode={isEditMode}
                            expenseGroup={editExpenseGroup}
                        />
                    </SideDrawerWrapper>
                )}
            </div>
        </>
    );
};

export default ExpenseGroups;
